import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

export type Handler = (event: MessageEvent) => void;

const useOpenGame = (onClose: Handler) => {
  const { modal } = useDispatch<Dispatch>();

  useEffect(() => {
    const listener = (event: MessageEvent) => {
      if (event?.data?.detail?.type === 'componentClose') {
        onClose(event);
      }
      if (event?.data?.detail?.type === 'ramRequest') {
        modal.enqueue({ path: '/account/cashier/deposit' });
      }
    };

    window.addEventListener('message', listener, false);
    return () => {
      window.removeEventListener('message', listener);
    };
  }, [modal, onClose]);
};

export default useOpenGame;
